module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lxm-cf-project-stat"
  }, [_c('lxm-stat', {
    staticClass: "lxm-cf-project-stat__stat"
  }), _vm._v(" "), _c('lxm-table', {
    attrs: {
      "heads": _vm.tableHeads,
      "rows": _vm.tableRows
    }
  })], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4379a6c2", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4379a6c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Main/Cf/Project/Stat.vue
// module id = 844
// module chunks = 0